import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {BrowserUtil} from '../browser.util';

@Directive({
    selector: '[appAcceptFormats]',
    providers: [BrowserUtil]
})
export class AcceptFormatsDirective implements OnInit {
    @Input()
    appAcceptFormats: string;

    constructor(private hostElement: ElementRef, private renderer: Renderer2,
                private browserUtil: BrowserUtil) {
    }

    ngOnInit(): void {
        const applicableFormats = this.browserUtil.isFacebookBrowser() ? null : this.appAcceptFormats;
        this.renderer.setAttribute(this.hostElement.nativeElement, 'accept', applicableFormats);
    }
}